import React, { useState, Suspense } from "react";
import "./App.css";
import Store from "./redux/store";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import ProfileOverview from "./pages/profile/ProfileOverviewNew";
import ProfileOrdersUnified from "./pages/profile/ProfileOrdersUnified";
import ProfileInbox from "./pages/profile/ProfileInbox";
import ProfileTrackOrders from "./pages/profile/ProfileTrackOrders";
import ProfileChangePassword from "./pages/profile/ProfileChangePassword";
import ProfileAddresses from "./pages/profile/ProfileAddresses";
import ProfileOffers from "./pages/profile/ProfileOffers";
import ProfileSellerDashboard from "./pages/profile/ProfileSellerDashboard";
import ProfileProducts from "./pages/profile/ProfileProducts";
import ProfileCreateProduct from "./pages/profile/ProfileCreateProduct";
import ProfileFeatureProduct from "./pages/profile/ProfileFeatureProduct";
import ProfileEvents from "./pages/profile/ProfileEvents";
import ProfileCreateEvent from "./pages/profile/ProfileCreateEvent";
import ProfileCreateService from "./pages/profile/ProfileCreateService";
import ProfileWithdraw from "./pages/profile/ProfileWithdraw";
import ProfileShopInbox from "./pages/profile/ProfileShopInbox";
import ProfileSellerRefunds from "./pages/profile/ProfileSellerRefunds";
import ProfileShopSettings from "./pages/profile/ProfileShopSettings";
import ProfileBundles from "./pages/profile/ProfileBundles";
import ProfileDisputesRefunds from "./pages/profile/ProfileDisputesRefunds";
import ProfileSellerOrderDetails from "./pages/profile/ProfileSellerOrderDetails";
import ProfileUserOrderDetails from "./pages/profile/ProfileUserOrderDetails";
import AllNotifications from "./pages/AllNotifications";
import ProfileVeteran from "./pages/profile/ProfileVeteran";
import ProfileServices from "./pages/profile/ProfileServices";
import ProfileMyReviews from "./pages/profile/ProfileMyReviews";
import {
  LoginPage,
  SignupPage,
  ActivationPage,
  HomePage,
  ProductsPage,
  BestSellingPage,
  BestDealsPage,
  FeaturedProductsPage,
  EventsPage,
  ServicesPage,
  FAQPage,
  AboutPage,
  PrivacyPage,
  TermsPage,
  BlogPage,
  SingleBlog,
  ContactPage,
  CheckoutPage,
  PaymentPage,
  OrderSuccessPage,
  ProductDetailsPage,
  SearchPage,
  ProfilePage,
  ShopCreatePage,
  SellerActivationPage,
  ShopLoginPage,
  OrderDetailsPage,
  TrackOrderPage,
  UserInbox,
  NotFound,
  ForgotPasswordPage,
  ResetPasswordPage,
} from "./routes/Routes";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminUserDetailsPage from "./pages/AdminUserDetailsPage";
import {
  ShopDashboardPage,
  ShopCreateProduct,
  ShopAllProducts,
  ShopCreateEvents,
  ShopAllEvents,
  ShopPreviewPage,
  ShopAllOrders,
  ShopOrderDetails,
  ShopAllRefunds,
  ShopRefundDetails,
  ShopSettingsPage,
  ShopWithDrawMoneyPage,
  ShopInboxPage,
  ShopDashboardBundles,
  ShopDashboardOffers,
} from "./routes/ShopRoutes";

import {
  AdminDashboardPage,
  AdminDashboardUsers,
  AdminDashboardSellers,
  AdminDashboardOrders,
  AdminDashboardEvents,
  AdminDashboardTotalSales,
  AdminDashboardEnquiries,
  AdminDashboardWithdraw,
  AdminDashboardPayments,
  AdminDashboardBundles,
  AdminDashboardOffers,
  AdminDashboardPages,
  AdminDashboardPagesHome,
  AdminDashboardPagesAbout,
  AdminDashboardPagesContact,
  AdminDashboardPagesTerms,
  AdminDashboardPagesPrivacy,
  AdminDashboardPagesBlog,
  AdminDashboardOptions,
  AdminDashboardOptionsHeader,
  AdminDashboardOptionsFooter,
  AdminDashboardOptionsCatalog,
  AdminDashboardOptionsEvents,
  AdminDashboardOptionsFeaturedProducts,
  AdminDashboardOptionsPayments,
  AdminDashboardOptionsEmail,
  AdminDashboardOptionsVeteranDiscount,
  AdminDashboardOptionsProductFilters,
  AdminDashboardOptionsMaintenance,
  AdminDashboardDiscounts,
  AdminDashboardOrderDetails,
  AdminNotificationsPage,
  AdminInboxPage,
} from "./routes/AdminRoutes";
import AdminDashboardStaff from "./pages/AdminDashboardStaff";
import AdminDashboardVeteranVerification from "./pages/AdminDashboardVeteranVerification";
import AdminDashboardVaMediation from "./pages/AdminDashboardVaMediation";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/mobileNoInputZoom.css";
import { useEffect } from "react";
import AgeVerification from "./components/Layout/AgeVerification";
import MaintenanceGate from "./components/Layout/MaintenanceGate";
import { loadUser } from "./redux/actions/user";
import { loadAdmin } from "./redux/actions/admin";
import { fetchSiteOptions } from "./redux/actions/siteOptions";
import ProtectedRoute from "./routes/ProtectedRoute";
import CancelRefundRequestPage from "./pages/CancelRefundRequestPage";
import ProtectedAdminRoute from "./routes/ProtectedAdminRoute";
import SellerProtectedRoute from "./routes/SellerProtectedRoute";
import { ShopHomePage } from "./ShopRoutes";
import { getAllProducts } from "./redux/actions/product";
import { getAllEvents } from "./redux/actions/event";
import axios from "axios";
import { server } from "./server";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { cacheStripeKeyResponse } from "./utils/stripePaymentUi";
import { DataGrid } from "@material-ui/data-grid";
import KlarnaCheckoutReturn from "./pages/KlarnaCheckoutReturn";
import StripePaymentReturn from "./pages/StripePaymentReturn";
import StripeReturnRedirect from "./components/Payment/StripeReturnRedirect";
import { NotificationProvider } from "./contexts/NotificationContext";
import ErrorBoundary from "./components/Layout/ErrorBoundary";
import GlobalModalScrollLock from "./components/Layout/GlobalModalScrollLock";
import MobileBottomNav, { shouldShowMobileBottomNav } from "./components/Layout/MobileBottomNav";
import AdminDashboardProducts from "./pages/AdminDashboardProducts";
import AdminDashboardServices from "./pages/AdminDashboardServices";
import AdminDashboardOptionsServices from "./pages/AdminDashboardOptionsServices";

DataGrid.defaultProps = {
  ...DataGrid.defaultProps,
  localeText: {
    ...(DataGrid.defaultProps?.localeText || {}),
    columnMenuSortAsc: "Oldest first",
    columnMenuSortDesc: "Newest first",
    columnMenuUnsort: "Clear sorting",
    columnMenuFilter: "Filter results",
    columnHeaderSortIconLabel: "Sort",
    filterPanelInputLabel: "Value",
    filterPanelOperator: "Condition",
    filterPanelInputPlaceholder: "Type to filter",
  },
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Small delay helps mobile browsers finish rendering before scrolling
    setTimeout(() => {
      // Try multiple methods to ensure it works across devices
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, Edge
    }, 100);
  }, [pathname]);

  return null;
};

const MobileNavGate = () => {
  const { pathname } = useLocation();
  const show = shouldShowMobileBottomNav(pathname);

  useEffect(() => {
    document.body.classList.toggle("has-mobile-bottom-nav", show);
    return () => document.body.classList.remove("has-mobile-bottom-nav");
  }, [show]);

  if (!show) return null;
  return <MobileBottomNav />;
};

/** Keeps iOS Safari from auto-zooming when inputs are focused (requires maximum-scale=1). */
const MobileInputZoomGuard = () => {
  useEffect(() => {
    const meta = document.querySelector('meta[name="viewport"]');
    if (!meta) return undefined;
    const locked =
      "width=device-width, initial-scale=1, maximum-scale=1";
    const apply = () => {
      if (
        window.matchMedia("(max-width: 799px)").matches ||
        window.matchMedia("(hover: none) and (pointer: coarse)").matches
      ) {
        meta.setAttribute("content", locked);
      }
    };
    apply();
    window.addEventListener("resize", apply);
    return () => window.removeEventListener("resize", apply);
  }, []);
  return null;
};


const App = () => {
  const [stripePromise, setStripePromise] = useState(null);

  async function getStripeApikey() {
    try {
      const { data } = await axios.get(`${server}/payment/stripe/key`);
      cacheStripeKeyResponse(data);
      if (data?.publishableKey) {
        setStripePromise(loadStripe(data.publishableKey.trim()));
      } else {
        setStripePromise(null);
      }
    } catch (error) {
      console.warn(
        "Stripe is not currently configured or reachable.",
        error?.response?.data?.message || error.message
      );
      setStripePromise(null);
    }
  }

  useEffect(() => {
    // Load user and admin data on app mount (only once)
    (async () => {
      const result = await Store.dispatch(loadUser());
      if (result?.accountDeleted) {
        toast.info(
          result.message ||
            "This account was deleted. Log in again if you want to reinstate it."
        );
      }
    })();
    // Try to load admin if adminToken exists (will fail silently if no token)
    Store.dispatch(loadAdmin());
    Store.dispatch(fetchSiteOptions("global"));
    // Load global data
    Store.dispatch(getAllProducts());
    Store.dispatch(getAllEvents());
    getStripeApikey();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty array ensures this only runs once on mount

const routes = (
  <Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
    <Route path="/reset-password" element={<ResetPasswordPage />} />
    <Route path="/sign-up" element={<SignupPage />} />
    <Route path="/activation/:activation_token" element={<ActivationPage />} />
    <Route path="/seller/activation/:activation_token" element={<SellerActivationPage />} />
    <Route path="/about" element={<AboutPage />} />
    <Route path="/terms-conditions" element={<TermsPage />} />
    <Route path="/privacy-policy" element={<PrivacyPage />} />
    <Route path="/blog" element={<BlogPage />} />
    <Route path="/blog/:slug" element={<SingleBlog />} />
    <Route path="/contact" element={<ContactPage />} />

    <Route path="/products" element={<ProductsPage />} />
    <Route path="/products/:mainSlug" element={<ProductsPage />} />
    <Route path="/products/:mainSlug/:subSlug" element={<ProductsPage />} />
    <Route path="/search" element={<SearchPage />} />
    <Route path="/product/:id" element={<ProductDetailsPage />} />
    <Route path="/best-deals" element={<BestDealsPage />} />
    <Route path="/featured-products" element={<FeaturedProductsPage />} />
    <Route path="/best-selling" element={<BestSellingPage />} />
    <Route path="/events" element={<EventsPage />} />
    <Route path="/services" element={<ServicesPage />} />
    <Route path="/faq" element={<FAQPage />} />
    <Route
      path="/checkout"
      element={
        <ProtectedRoute>
          <CheckoutPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/payment"
      element={
        <ProtectedRoute>
          <PaymentPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/klarna/checkout/return"
      element={
        <ProtectedRoute>
          <KlarnaCheckoutReturn />
        </ProtectedRoute>
      }
    />
    <Route path="/payment/stripe-return" element={<StripePaymentReturn />} />
    <Route path="/order/success" element={<OrderSuccessPage />} />
    <Route path="/orders" element={<Navigate to="/profile/orders" replace />} />
    <Route
      path="/profile"
      element={
        <ProtectedRoute>
          <ProfilePage />
        </ProtectedRoute>
      }
    >
      <Route index element={<Navigate to="/profile/overview" replace />} />
      <Route path="overview" element={<ProfileOverview />} />
      <Route path="orders" element={<ProfileOrdersUnified />} />
      <Route path="inbox" element={<ProfileInbox />} />
      <Route path="track-orders" element={<ProfileTrackOrders />} />
      <Route path="change-password" element={<ProfileChangePassword />} />
      <Route path="addresses" element={<ProfileAddresses />} />
      <Route path="offers" element={<ProfileOffers />} />
      <Route path="dashboard" element={<ProfileSellerDashboard />} />
      <Route path="seller-orders" element={<Navigate to="/profile/orders?view=selling" replace />} />
      <Route path="review-orders" element={<Navigate to="/profile/orders?view=selling" replace />} />
      <Route path="products" element={<ProfileProducts />} />
      <Route path="create-product" element={<ProfileCreateProduct />} />
      <Route path="feature-product" element={<ProfileFeatureProduct />} />
      <Route path="events" element={<ProfileEvents />} />
      <Route path="create-event" element={<ProfileCreateEvent />} />
      <Route path="services" element={<ProfileServices />} />
      <Route path="create-service" element={<ProfileCreateService />} />
      <Route path="withdraw" element={<ProfileWithdraw />} />
      <Route path="shop-inbox" element={<ProfileShopInbox />} />
      <Route path="disputes-refunds" element={<ProfileDisputesRefunds />} />
      {/* Redirect old refund routes to new unified disputes-refunds page */}
      <Route path="seller-refunds" element={<Navigate to="/profile/disputes-refunds?tab=review-refunds" replace />} />
      <Route path="refunds" element={<Navigate to="/profile/disputes-refunds?tab=my-refunds" replace />} />
      <Route path="shop-settings" element={<ProfileShopSettings />} />
      <Route path="bundles" element={<ProfileBundles />} />
      <Route path="seller-offers" element={<Navigate to="/profile/offers?view=selling" replace />} />
      <Route path="seller-order/:id" element={<ProfileSellerOrderDetails />} />
      <Route path="order/:id" element={<ProfileUserOrderDetails />} />
      <Route path="notifications" element={<AllNotifications />} />
      <Route path="veteran" element={<ProfileVeteran />} />
      <Route path="my-reviews" element={<ProfileMyReviews />} />
    </Route>
    <Route
      path="/inbox"
      element={
        <ProtectedRoute>
          <UserInbox />
        </ProtectedRoute>
      }
    />
    <Route
      path="/user/order/:id/cancel-refund"
      element={
        <ProtectedRoute>
          <CancelRefundRequestPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/user/order/:id"
      element={
        <ProtectedRoute>
          <OrderDetailsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/user/track/order/:id"
      element={
        <ProtectedRoute>
          <TrackOrderPage />
        </ProtectedRoute>
      }
    />
    <Route path="/shop/preview/:id" element={<ShopPreviewPage />} />
    <Route path="/shop/:id" element={<ShopPreviewPage />} />
    {/* Shop create and login routes removed - use /sign-up and /login instead */}
    <Route
      path="/seller/shop/:id"
      element={
        <SellerProtectedRoute>
          <ShopHomePage />
        </SellerProtectedRoute>
      }
    />
    <Route
      path="/settings"
      element={
        <SellerProtectedRoute>
          <ShopSettingsPage />
        </SellerProtectedRoute>
      }
    />
    {/* Redirect old dashboard routes to proper profile routes */}
    <Route
      path="/dashboard-bundles"
      element={
        <SellerProtectedRoute>
          <Navigate to="/profile/bundles" replace />
        </SellerProtectedRoute>
      }
    />
    <Route
      path="/dashboard-offers"
      element={
        <SellerProtectedRoute>
          <Navigate to="/profile/offers?view=selling" replace />
        </SellerProtectedRoute>
      }
    />
    <Route
      path="/dashboard"
      element={
        <SellerProtectedRoute>
          <Navigate to="/profile/dashboard" replace />
        </SellerProtectedRoute>
      }
    />
    <Route
      path="/dashboard-create-product"
      element={
        <SellerProtectedRoute>
          <Navigate to="/profile/create-product" replace />
        </SellerProtectedRoute>
      }
    />
    <Route
      path="/dashboard-orders"
      element={
        <SellerProtectedRoute>
          <Navigate to="/profile/orders?view=selling" replace />
        </SellerProtectedRoute>
      }
    />
    <Route
      path="/dashboard-refunds"
      element={
        <SellerProtectedRoute>
          <Navigate to="/profile/disputes-refunds?tab=review-refunds" replace />
        </SellerProtectedRoute>
      }
    />
    <Route
      path="/refund/:id"
      element={
        <SellerProtectedRoute>
          <ShopRefundDetails />
        </SellerProtectedRoute>
      }
    />
    <Route
      path="/order/:id"
      element={
        <SellerProtectedRoute>
          <ShopOrderDetails />
        </SellerProtectedRoute>
      }
    />
    <Route
      path="/dashboard-products"
      element={
        <SellerProtectedRoute>
          <Navigate to="/profile/products" replace />
        </SellerProtectedRoute>
      }
    />
    <Route
      path="/dashboard-withdraw-money"
      element={
        <SellerProtectedRoute>
          <Navigate to="/profile/withdraw" replace />
        </SellerProtectedRoute>
      }
    />
    <Route
      path="/dashboard-messages"
      element={
        <SellerProtectedRoute>
          <Navigate to="/profile/inbox" replace />
        </SellerProtectedRoute>
      }
    />
    <Route
      path="/dashboard-create-event"
      element={
        <SellerProtectedRoute>
          <Navigate to="/profile/create-event" replace />
        </SellerProtectedRoute>
      }
    />
    <Route
      path="/dashboard-events"
      element={
        <SellerProtectedRoute>
          <Navigate to="/profile/events" replace />
        </SellerProtectedRoute>
      }
    />
    <Route
      path="/dashboard-create-service"
      element={
        <SellerProtectedRoute>
          <Navigate to="/profile/create-service" replace />
        </SellerProtectedRoute>
      }
    />
    <Route
      path="/dashboard-services"
      element={
        <SellerProtectedRoute>
          <Navigate to="/profile/services" replace />
        </SellerProtectedRoute>
      }
    />
    <Route path="/admin/login" element={<AdminLoginPage />} />
    <Route
      path="/admin/dashboard"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardPage />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/notifications"
      element={
        <ProtectedAdminRoute>
          <AdminNotificationsPage />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/inbox"
      element={
        <ProtectedAdminRoute>
          <AdminInboxPage />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin-users"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardUsers />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin-user/:id"
      element={
        <ProtectedAdminRoute>
          <AdminUserDetailsPage />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin-sellers"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardSellers />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin-orders"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardOrders />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin-order/:id"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardOrderDetails />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/va-mediation"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardVaMediation />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin-products"
      element={
        <ProtectedAdminRoute>
          <Suspense fallback={<div className="min-h-screen flex items-center justify-center bg-slate-50"><div className="text-slate-500">Loading…</div></div>}>
            <AdminDashboardProducts />
          </Suspense>
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin-events"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardEvents />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin-services"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardServices />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin-veteran-verifications"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardVeteranVerification />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin-total-sales"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardTotalSales />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin-enquiries"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardEnquiries />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin-withdraw-request"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardWithdraw />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin-payments"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardPayments />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin-bundles"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardBundles />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin-offers"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardOffers />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/blogs"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardPagesBlog />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/options"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardOptions />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/options/header"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardOptionsHeader />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/options/footer"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardOptionsFooter />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/options/catalog"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardOptionsCatalog />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/options/events"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardOptionsEvents />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/options/services"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardOptionsServices />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/options/featured-products"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardOptionsFeaturedProducts />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/options/payments"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardOptionsPayments />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/options/email"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardOptionsEmail />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/options/veteran-discount"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardOptionsVeteranDiscount />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/options/product-filters"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardOptionsProductFilters />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/options/maintenance"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardOptionsMaintenance />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/discounts"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardDiscounts />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/staff"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardStaff />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/pages"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardPages />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/pages/home"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardPagesHome />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/pages/about"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardPagesAbout />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/pages/contact"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardPagesContact />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/pages/terms"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardPagesTerms />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/pages/privacy"
      element={
        <ProtectedAdminRoute>
          <AdminDashboardPagesPrivacy />
        </ProtectedAdminRoute>
      }
    />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

return (
  <ErrorBoundary>
    <BrowserRouter>
      <ScrollToTop />
      <MobileInputZoomGuard />
      <StripeReturnRedirect />
      <GlobalModalScrollLock />
      <AgeVerification />
      <NotificationProvider>
        <MaintenanceGate>
          {routes}
          <MobileNavGate />
        </MaintenanceGate>
      </NotificationProvider>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        style={{ zIndex: 100010 }}
      />
    </BrowserRouter>
  </ErrorBoundary>
);
};
export default App;
